import defaults from 'lodash/defaults';
import getSplashApiClient from 'lib/SplashApiClient/singleton';

const DEFAULT_HUB_SORT = 'modified_desc';
const DEFAULT_HUB_LIMIT = 20;
const HUB_VIEW_GROUP = 'splashHubList';

/**
 * Wraps a SplashApiClient with the Hubs Dashboard API actions
 */
export default class HubsApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Get hubs based on passed criteria
     * @param  {object} options
     * @param  {string} options.sort - What field to sort on
     * @param  {number} options.limit - Max # of results
     * @param  {string} options.search - Term for filtering results
     * @param  {number} options.page - Page to fetch based on limit
     * @param  {string} options.event_types - Event type id
     * @return {promise}
     */
    fetchHubs(options = {}) {
        const fetchOptions = defaults(options, {
            hubs: 1,
            viewGroups: [HUB_VIEW_GROUP],
            sort: DEFAULT_HUB_SORT,
            limit: DEFAULT_HUB_LIMIT,
        });

        if (fetchOptions.limit == null) {
            delete fetchOptions.limit;
        }

        return this.apiClient.get('/events', fetchOptions);
    }

    /**
     * Search through hubs
     * @param  {string} search - Search term
     * @param  {object} options - Same as fetchHubs method
     * @return {promise}
     */
    searchHubs(search, options = {}) {
        const searchOptions = {
            ...options,
            search,
            limit: null,
        };

        return this.fetchHubs(searchOptions);
    }

    /**
     * Add multiple events to multiple hubs
     * @param {Array} eventIds
     * @param {Array} hubIds
     * @param {boolean} featured
     */
    addEventsToHubs(eventIds = [], hubIds = [], featured = false) {
        if (!eventIds.length || !hubIds.length) {
            throw new Error('Event Ids or Hub Ids cannot be empty');
        }

        return this.apiClient.post('/hubs/items', {
            event_ids: eventIds,
            splash_hub_ids: hubIds,
            featured,
        });
    }

    getHubsContainingEvent(eventId) {
        const url = `/hubs/with/event/${eventId}`;

        return this.apiClient.get(url);
    }
}

export const getHubsApiClient = () => new HubsApiClient(getSplashApiClient());
